import api from './apiClient';

const apiProofreadCaption = async (text, layout, onUnavailable) => {
    try {
        const response = await api.post(
            '/api/captions/proofread-caption',
            { text, layout },
            { timeout: 3500 }
        );
        const proofreadText = response.data?.proofreadText;
        return {
            text: typeof proofreadText === 'string' && proofreadText.trim()
                ? proofreadText.trim()
                : text,
            isCaption: response.data?.isCaption !== false,
            sourceLanguage: response.data?.sourceLanguage || null,
        };
    } catch (error) {
        console.warn('Caption proofreading unavailable; using local OCR text.');
        onUnavailable?.(error);
        return { text, isCaption: true, sourceLanguage: null };
    }
};

export default apiProofreadCaption;
